import React from 'react';
import { useLoginContext } from '../../../Contexts/LoginContext';
import { formatCpf } from '../../../Utils/Formatters';
import ButtonLink from '../../Form/ButtonLink';
import { useNavigate } from 'react-router-dom';

const CardProfileBasicInfo = () => {

  const { user } = useLoginContext();
  const navigate  = useNavigate();

  return (
      <div className='flex flex-col gap-2 w-full h-full'>
        <h4 className='font-semibold'>Informações básicas</h4>
        <div className='px-1 h-full'>
          <div>
              <span className="text-gray-400 leading-none">Nome: </span>
              <span className="font-semibold">{ user.first_name.trim() ? user.first_name : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">Sobrenome: </span>
              <span className="font-semibold">{ user.last_name.trim() ? user.last_name : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">Email: </span>
              <span className="font-semibold">{ user.email ? user.email : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">CPF: </span>
              <span className="font-semibold">{ user.cpf ? formatCpf(user.cpf) : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">Aniversário: </span>
              <span className="font-semibold">{ user.birthdate ? user.birthdate : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">Gênero: </span>
              <span className="font-semibold">{ user.gender ? user.gender : '-' }</span>
          </div>
          <div>
              <span className="text-gray-400 leading-none">Programa de fidelidade: </span>
              <span className="font-semibold">{ user.on_fidelity_program ? 'Sim' : 'Não' }</span>
          </div>
        </div>
        <div className='flex justify-between'>
            <ButtonLink disabled onClick={() => navigate('/perfil/dados-cadastrais')} className="text-xs">Editar</ButtonLink>
        </div>
      </div>
    
  )
}

export default CardProfileBasicInfo;